import { AddToSamplesButton } from '../components/product-samples/add-to-samples-button-component';
import { ToggleQuickshopSidebar } from '../components/product-quickshop/toggle-quickshop-component';

const initialiseRelatedProductSliderVueComponents = () => {
  const relatedProductSliders = document.querySelectorAll(
    'div[data-related-product-slider]'
  );

  if (relatedProductSliders.length) {
    relatedProductSliders.forEach((slider) => {
      const sliderID = slider.getAttribute('id');
      new Vue({
        el: `#${sliderID}`,
        components: {
          'add-to-samples': AddToSamplesButton,
          'toggle-quickshop': ToggleQuickshopSidebar,
        },
        data: {
          ctaButtonIsEnabled: true,
        },
      });
    });
  }
};

const PageFlexibleContentModulesTemplate = () => {
  const isFlexibleModuleTemplate = $('body').hasClass(
    'template-page-flexible-content-modules'
  );

  if (!isFlexibleModuleTemplate) {
    return false;
  }

  initialiseRelatedProductSliderVueComponents();
};

export default PageFlexibleContentModulesTemplate;
